export default __webpack_public_path__ + "static/grapefinance-20b44ebd8f2c71fdc1025414ee40ad01.jpg";